// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05489da8","455":"cfbb9608","977":"c1d2e00a"}[chunkId] + ".chunk.js";
};